import { WebUtils, LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import {
    commonHeaders,
    buildConfig,
    callWebUtils,
    triggerDownload,
    checkForErrors,
} from './commonApiUtil';

export const downloadAttachment = async (
    config: LoruleRequestConfig,
    amId: number,
    attachmentId: number,
    setAttachmentError: Function,
    user: boolean = true,
) => {
    try {
        const result = await WebUtils.requestWithHeaders(
            buildConfig(config, `/actionmemo/${amId}/attachment/${attachmentId}?user=${user}`),
            'GET',
            null,
            {},
        );

        if (result) {
            if (result.status !== 200) {
                const body = await result.json();
                checkForErrors(body);
            } else {
                await triggerDownload(result);
                setAttachmentError('');
            }
        }
    } catch (e) {
        if (e instanceof Error) {
            setAttachmentError(`Download attachment failed:  ${e.message}`);
        }
    }
};

export const addAttachment = async (
    config: LoruleRequestConfig,
    amId: number,
    description: string,
    commentMessage: string,
    file: File,
    user: boolean = true,
) => {
    const formData = new FormData();

    formData.append('description', description);
    formData.append('commentMessage', commentMessage);
    formData.append('file', file);

    const result = await WebUtils.requestWithHeaders(
        buildConfig(config, `/actionmemo/${amId}/attachment?user=${user}`),
        'POST',
        formData,
        {},
    );

    if (result && result.status !== 204) {
        const body = await result.json();
        checkForErrors(body);
    }
    return null;
};

export const updateAttachment = async (
    config: LoruleRequestConfig,
    amId: number,
    attachmentId: number,
    description: string,
    commentMessage: string,
    file: File,
    user: boolean = true,
) => {
    const formData = new FormData();

    formData.append('description', description);
    formData.append('commentMessage', commentMessage);
    formData.append('file', file);

    const result = await WebUtils.requestWithHeaders(
        buildConfig(config, `/actionmemo/${amId}/attachment/${attachmentId}?user=${user}`),
        'PUT',
        formData,
        {},
    );
    if (result && result.status !== 204) {
        const body = await result.json();
        checkForErrors(body);
    }
    return null;
};

export const deleteAttachment = async (
    config: LoruleRequestConfig,
    amId: number,
    attachmentId: number,
    user: boolean = true,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/attachment/${attachmentId}?user=${user}`,
        'DELETE',
        null,
        commonHeaders,
    );
